/**
 * Supported AWS commercial regions for the dashboard's multi-region UI.
 * Mirrors services/shared/aws-regions.ts (kept in sync manually — the dashboard
 * cannot import from the backend workspace).
 */

export interface AwsRegionOption {
  code:  string;
  label: string;
}

export const SUPPORTED_AWS_REGIONS: AwsRegionOption[] = [
  { code: 'us-east-1',      label: 'US East (N. Virginia)' },
  { code: 'us-east-2',      label: 'US East (Ohio)' },
  { code: 'us-west-1',      label: 'US West (N. California)' },
  { code: 'us-west-2',      label: 'US West (Oregon)' },
  { code: 'ca-central-1',   label: 'Canada (Central)' },
  { code: 'eu-west-1',      label: 'Europe (Ireland)' },
  { code: 'eu-west-2',      label: 'Europe (London)' },
  { code: 'eu-west-3',      label: 'Europe (Paris)' },
  { code: 'eu-central-1',   label: 'Europe (Frankfurt)' },
  { code: 'eu-north-1',     label: 'Europe (Stockholm)' },
  { code: 'ap-south-1',     label: 'Asia Pacific (Mumbai)' },
  { code: 'ap-southeast-1', label: 'Asia Pacific (Singapore)' },
  { code: 'ap-southeast-2', label: 'Asia Pacific (Sydney)' },
  { code: 'ap-northeast-1', label: 'Asia Pacific (Tokyo)' },
  { code: 'ap-northeast-2', label: 'Asia Pacific (Seoul)' },
  { code: 'ap-northeast-3', label: 'Asia Pacific (Osaka)' },
  { code: 'sa-east-1',      label: 'South America (São Paulo)' },
];

/** Scope sentinel for global / account-scoped services (e.g. CloudFront). */
export const GLOBAL_SCOPE = 'global';

/** Scope sentinel for "all enabled regions" aggregation. */
export const ALL_REGIONS_SCOPE = 'all';

const SUPPORTED = new Set(SUPPORTED_AWS_REGIONS.map(r => r.code));

export function isSupportedRegion(region: string): boolean {
  return SUPPORTED.has(region);
}

export function regionLabel(code: string): string {
  return SUPPORTED_AWS_REGIONS.find(r => r.code === code)?.label ?? code;
}
